import Layout from '@/layout';
var financeRouter = {
  path: '/finance',
  component: Layout,
  redirect: '/finance/settlement-management',
  name: 'finance',
  alwaysShow: true,
  meta: {
    title: '财务管理',
    icon: 'clipboard'
  },
  children: [{
    path: 'settlement-management',
    component: function component(resolve) {
      return require(['@/views/my-create/financial-management/settlement-management/index.vue'], resolve);
    },
    name: 'settlement-management',
    meta: {
      title: '结算管理',
      icon: ''
    }
  }, {
    path: 'financial-details',
    component: function component(resolve) {
      return require(['@/views/my-create/financial-management/financial-details/index.vue'], resolve);
    },
    name: 'financial-details',
    meta: {
      title: '明细列表',
      icon: ''
    }
  }, {
    path: 'payment',
    component: function component(resolve) {
      return require(['@/views/my-create/financial-management/payment/index.vue'], resolve);
    },
    name: 'payment',
    meta: {
      title: '支付管理',
      icon: ''
    }
  }]
};
export default financeRouter;